export default __webpack_public_path__ + "static/media/대전청년하우스 입주자 모집 공고문.87f85657.pdf";